import React from 'react';
import './App.css';
import PathfinderVisualizer from './PathfinderVisualizer/PathfinderVisualizer';

function App() {
  return (
    <div className="App">
      <PathfinderVisualizer></PathfinderVisualizer>
    </div>
  );
}

export default App;
